import { getBodyAverageValues } from "../../../../commons/libs/sizing-service";
import { useSettings } from "../queries/use-settings";

import useQuery from "./use-query";

const useSizingAvailability = ({ isOnline = true }: { isOnline: boolean }) => {
  const settings = useSettings();

  const query = useQuery({
    enabled: isOnline && settings.isBodySizingEnabled,
    queryKey: ["sizingAvailability"],
    queryFn: () => getBodyAverageValues(180),
    staleTime: 5 * 60 * 1000 // 5 minutes
  });

  const isFetching = query.isFetching;
  const available = isOnline && !query.isFetching && !query.error;

  return {
    isFetching,
    available
  };
};

export default useSizingAvailability;
